import { render, staticRenderFns } from "./reggisterForm.vue?vue&type=template&id=b4544418&scoped=true"
import script from "./reggisterForm.vue?vue&type=script&lang=js"
export * from "./reggisterForm.vue?vue&type=script&lang=js"
import style0 from "./reggisterForm.vue?vue&type=style&index=0&id=b4544418&prod&lang=css"
import style1 from "./reggisterForm.vue?vue&type=style&index=1&id=b4544418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4544418",
  null
  
)

export default component.exports